import { createSlice } from '@reduxjs/toolkit';

import { createRestSlice } from '../../utils/RestSlice';
import UserRepository from '../../repositories/Admin/UserRepository';

const userRestSlice = createRestSlice({
  resource: 'user',
  repository: UserRepository,
  slices: ['loadUsers'],
});

const initialState = {
  ...userRestSlice.initialState,
};

const userSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    ...userRestSlice.reducers,
  },
});
export default userSlice.reducer;

export const userRestHooks = userRestSlice.hooks(userSlice, [
  'admin',
  'UserSlice',
]);
